// Create Redux action types
export const HIDE_SIDEMENU = 'HIDE_SIDEMENU'


// Create Redux action creators that return an action
export const hideSideMenuToggle = () => ({
    type: HIDE_SIDEMENU,
})


export function hideSideMenu() {
    return dispatch => {
        dispatch(hideSideMenuToggle())
    }
}
